import React, { Component } from 'react';
import moment from 'moment';
import ReactDataGrid from 'react-data-grid';
import DateTimePicker from 'react-widgets/lib/DateTimePicker';
import { Data } from 'react-data-grid-addons';
import { Translate } from 'react-redux-i18n';
import { SkyLightStateless } from 'react-skylight';
import { Grid, Row, Col, Panel, Input, Button, Breadcrumb, ButtonToolbar } from 'react-bootstrap';

import ContentWrapper from '../../components/Layout/ContentWrapper';
import { UI_HEIGHT } from '../Common/constants';
import Spinner from '../../components/Widgets/spinner';
import CashOutModal from '../../containers/Sales/cashOutModal';
import LogModal from '../../containers/Sales/logModal';
import { toFromDates } from '../Common/cleanDates';

import { ROOT_URL, isARC, isGFD, isSH, isAP, isTU, isCTP } from '../../actions/root_url';

class PosReport extends Component {
  static contextTypes = {
    router: React.PropTypes.object
  };

  constructor() {
    super();
    this.state = {
      // Track size of window and update grid height
      tableHeight: window.innerHeight - UI_HEIGHT.oneLineButton,

      // Modal visibility
      CashOutModalOpen: false,
      LogModalOpen: false,

      // Hold data to be displayed in report grid
      report: {
        filters: {},
        selectedRows: [],
        sortColumn: null,
        sortDirection: null,
        startDate: '',
        endDate: '',
      },

      // Division that we are searching for
      division: '',

      // ID if specified
      divisionID: '',

      type: 'all',
      salesID: null,

      // Collapse status of the panels
      openStatus: [],

      // Report totals
      totalInvoice: 0,
      totalReturn: 0,
      totalCredit: 0,
      grandTotal: 0,
      rowProps: {},
      errorState: {
        message: '',
        status: '',
      },
      curRegisterId: '',
      session_id: null,

      // Date to print for registers
      RegistersDate: null,
      FromDate: null,
      ToDate: null,
    };

    this.handleResize = this.handleResize.bind(this);
    this.closeCashOutModal = this.closeCashOutModal.bind(this);
    this.openCashOutModal = this.openCashOutModal.bind(this);
    this.closeLogModal = this.closeLogModal.bind(this);
    this.openLogModal = this.openLogModal.bind(this);
  }

  componentWillMount() {
    this.props.fetchRegisters(this.formatDate(new Date()), this.formatDate(new Date()), this.props.selectedCompany);
    this.setState({ RegistersDate: new Date(), FromDate: new Date(), ToDate: new Date() });
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    const {
      FromDate,
      ToDate,
      registerID,
    } = this.props;
    if (FromDate && ToDate) {
      this.setState({
        FromDate,
        ToDate,
        curRegisterId: registerID,
      })
    }
    // this.props.setValue('posReport', 'Days', '1');
    // this.props.setValue('posReport', 'Types', 'all');
    // this.props.fetchPosReport(this.state.type, 1, '1900-01-01', this.formatDate(new Date()), this.state.division, this.state.divisionID, this.state.salesID);
    // this.props.fetchGroups();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.sessions.constructor === Array) {
      const newRows = [...nextProps.sessions];

      for (let i = 0; i < newRows.length; i++) {
        const date = new Date(newRows[i].CashInTime);
        let formattedDate = `${date.getFullYear()}-`;
        formattedDate += `${date.getMonth() + 1}-`;
        if (date.getDate() < 10) {
          formattedDate += `0${date.getDate()}`;
        } else {
          formattedDate += date.getDate();
        }
        let CashInTime = '';
        if (newRows[i].CashInTime) {
          CashInTime = moment.utc(newRows[i].CashInTime).local().format('LT');
          //CashInTime = newRows[i].CashInTime;
          //CashInTime = CashInTime.substring(CashInTime.indexOf('T') + 1, CashInTime.indexOf('T') + 6);
        }
        let CashOutTime = '';
        if (newRows[i].CashOutTime) {
          CashOutTime = moment.utc(newRows[i].CashOutTime).local().format('LT');
          //CashOutTime = newRows[i].CashOutTime;
          //CashOutTime = CashOutTime.substring(CashOutTime.indexOf('T') + 1, CashOutTime.indexOf('T') + 6);
        }
        newRows[i].Date = formattedDate;
        newRows[i].NewCashInTime = CashInTime;
        newRows[i].NewCashOutTime = CashOutTime;
        let CashInBy = ' ';
        let CashOutBy = ' ';
        for (let k = 0; k < newRows[i].SessionLogs.length; k++) {
          if (newRows[i].SessionLogs[k].IsCashInOrCashOut) {
            CashInBy = newRows[i].SessionLogs[k].User;
          } else if (newRows[i].SessionLogs[k].IsCashInOrCashOut !== null) {
            CashOutBy = newRows[i].SessionLogs[k].User;
            if (newRows[i].SessionLogs.length === 1) {
              CashInBy = newRows[i].SessionLogs[k].User;
            }
            newRows[i].NeedsVerification = true;
          }
          if (newRows[i].Verifier) {
            newRows[i].NeedsVerification = false;
          }
        }
        newRows[i].CashInBy = CashInBy;
        newRows[i].CashOutBy = CashOutBy;
      }
      this.setState({
        report: {
          rows: newRows,
          selectedRows: [],
          sortColumn: null,
          sortDirection: null,
          startDate: '',
          endDate: '',
        },
      });
    }

    if (nextProps.sessions.POS_Sessions) {
      if (nextProps.sessions.POS_Sessions[0]) {
        for (let i = 0; i < nextProps.sessions.POS_Sessions.length; i++) {
          // let date = nextProps.sessions.POS_Sessions[0].SessionLogs[i].LogInTime;
          const date = new Date(nextProps.sessions.POS_Sessions[i].CashInTime);
          let formattedDate = `${date.getFullYear()}-`;
          formattedDate += `${date.getMonth() + 1}-`;
          if (date.getDate() < 10) {
            formattedDate += `0${date.getDate()}`;
          } else {
            formattedDate += date.getDate();
          }
          let CashInTime = '';
          if (nextProps.sessions.POS_Sessions[i].CashInTime) {
            CashInTime = moment.utc(nextProps.sessions.POS_Sessions[i].CashInTime).local().format('LT');
            //CashInTime = nextProps.sessions.POS_Sessions[i].CashInTime;
            //CashInTime = CashInTime.substring(CashInTime.indexOf('T') + 1, CashInTime.indexOf('T') + 6);
          }
          let CashOutTime = '';
          if (nextProps.sessions.POS_Sessions[i].CashOutTime) {
            CashOutTime = moment.utc(nextProps.sessions.POS_Sessions[i].CashOutTime).local().format('LT');
            //CashOutTime = nextProps.sessions.POS_Sessions[i].CashOutTime;
            //CashOutTime = CashOutTime.substring(CashOutTime.indexOf('T') + 1, CashOutTime.indexOf('T') + 6);
          }
          nextProps.sessions.POS_Sessions[i].Date = formattedDate;
          nextProps.sessions.POS_Sessions[i].NewCashInTime = CashInTime;
          nextProps.sessions.POS_Sessions[i].NewCashOutTime = CashOutTime;
          let CashInBy = ' ';
          let CashOutBy = ' ';
          for (let k = 0; k < nextProps.sessions.POS_Sessions[i].SessionLogs.length; k++) {
            if (nextProps.sessions.POS_Sessions[i].SessionLogs[k].IsCashInOrCashOut) {
              CashInBy = nextProps.sessions.POS_Sessions[i].SessionLogs[k].User;
            } else if (nextProps.sessions.POS_Sessions[i].SessionLogs[k].IsCashInOrCashOut !== null) {
              CashOutBy = nextProps.sessions.POS_Sessions[i].SessionLogs[k].User;
              if (nextProps.sessions.POS_Sessions[i].SessionLogs.length === 1) {
                CashInBy = nextProps.sessions.POS_Sessions[i].SessionLogs[k].User;
              }
              nextProps.sessions.POS_Sessions[i].NeedsVerification = true;
            }
            if (nextProps.sessions.POS_Sessions[i].Verifier) {
              nextProps.sessions.POS_Sessions[i].NeedsVerification = false;
            }
          }
          nextProps.sessions.POS_Sessions[i].CashInBy = CashInBy;
          nextProps.sessions.POS_Sessions[i].CashOutBy = CashOutBy;
        }
        this.setState({
          report: {
            rows: nextProps.sessions.POS_Sessions,
            selectedRows: [],
            sortColumn: null,
            sortDirection: null,
            startDate: '',
            endDate: '',
          },
        });
      } else {
        this.setState({
          report: {
            rows: [],
            selectedRows: [],
            sortColumn: null,
            sortDirection: null,
            startDate: '',
            endDate: '',
          },
        });
      }
    } else {
      if (this.state.curRegisterId && this.state.FromDate && this.state.ToDate && !Array.isArray(nextProps.sessions)) {
        this.props.fetchRegisterSessionsByDate(this.state.curRegisterId, this.state.FromDate, this.state.ToDate, this.props.selectedCompany);
      } else if (this.state.curRegisterId && !Array.isArray(nextProps.sessions)) {
        this.props.fetchRegisterSessions(this.state.curRegisterId, this.selectedCompany);
      }
    }
    if (nextProps.posReport && nextProps.posReport !== this.props.posReport) {
      const report = { ...this.state.report, rows: nextProps.posReport };
      let grandTotal = 0;
      let totalInvoice = 0;

      report.rows.map(row => {
        row.Date = row.FromDate.substring(0, 10) + ' to ' + row.EndDate.substring(0, 10);
        grandTotal += row.GrandTotal;
        totalInvoice += row.InvoiceAmount;
        row.GrandTotal = this.format(row.GrandTotal.toFixed(2));
        row.InvoiceAmount = this.format(row.InvoiceAmount.toFixed(2));
        row.GrandTotal = "$" + row.GrandTotal;
      });
      this.setState({ report, grandTotal, totalInvoice });
    }

    if ((isGFD || isCTP) && nextProps.selectedCompany && nextProps.selectedCompany !== this.props.selectedCompany) {
      this.props.fetchRegisters(this.formatDate(new Date()), this.formatDate(new Date()), nextProps.selectedCompany);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize(e) {
    this.setState({ tableHeight: window.innerHeight - UI_HEIGHT.oneLineButton });
  }

  formatDate(date) {
    if (date == null) { date = new Date(); }
    let formattedDate = date.getFullYear() + '-';

    formattedDate += date.getMonth()+1 + '-';
    if (date.getDate() < 10) {
      formattedDate += '0' + date.getDate();
    } else {
      formattedDate += date.getDate();
    }

    return formattedDate;
  }

  format(num) {
    const n = num.toString();
    const p = n.indexOf('.');
    return n.replace(/\d(?=(?:\d{3})+(?:\.|$))/g, ($0, i) => {
        return p < 0 || i < p ? ($0 + ',') : $0;
    });
  }

  getAmountSummary(props) {
    if (props === null || props === []) {
      return {};
    }
    const summary = {
      transactions: props.Transactions,
      totalCashAmount: props.TotalCashAmount,
      creditCards: props.CreditCards,
      ebtCards: props.EBTCards,
      checks: props.Checks,
      storeCredit: props.StoreCredit,
      totalPaidOut: props.TotalPaidOut,
      totalNetSale: props.TotalNetSale,
      salesTax: props.SalesTax,
      totalSale: props.TotalSale,
      giftcards: props.Giftcards,
      Profit: props.Profit,
      TotalArrivalPrice: props.TotalArrivalPrice,
      MobileAmount: props.MobileAmount ? props.MobileAmount : 0,
    };
    return summary;
  }

  closeCashOutModal() { this.setState({ CashOutModalOpen: false }); }
  openCashOutModal(rowProps) { this.setState({ CashOutModalOpen: true, rowProps }); }

  closeLogModal() { this.setState({ LogModalOpen: false }); }
  openLogModal(rowProps) { this.setState({ LogModalOpen: true, rowProps }); }

  renderReportTable() {
    if (this.props.sessionsIsLoading && !this.props.sessionsError) {
      return (
        <div id="spinner">
          <Spinner />
        </div>
      );
    } else if (this.props.sessionsError) {
      return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.posReportError)}</div></ContentWrapper>;
    }

    // Parameters of the react-data-grid
    const tableHeight = (window.innerHeight < 930) ? 572 : 572;

    const getRows = () => Data.Selectors.getRows(this.state.report);

    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    // Handle the sortable function
    const handleGridSort = (sortColumn, sortDirection) => {
      const state = Object.assign({}, this.state.report, { sortColumn, sortDirection });
      this.setState({ report: state });
    };

    const handleFilterChange = (filter) => {
      const newFilters = Object.assign({}, this.state.report.filters);
      if (filter.filterTerm) {
        newFilters[filter.column.key] = filter;
      } else {
        delete newFilters[filter.column.key];
      }
      const report = { ...this.state.report, filters: newFilters };
      this.setState({ report });
    };

    const handleRowUpdated = (e) => {
      const rows = getRows();
      Object.assign(rows[e.rowIdx], e.updated);
      const report = { ...this.state.report, rows };
      this.setState({ report });
    };

    // Handle the row select function
    const onRowSelect = (rows) => {
      const report = { ...this.state.report, selectedRows: rows };
      this.setState({ report });
    };

    const onRowsSelected = (rows) => {
      const newRows = [...this.state.report.rows];
      let selectedRows = this.state.report.selectedRows;

      newRows.map((r) => {
        r.isSelected = false;
      });

      selectedRows = [rows.row];
      newRows[rows[0].rowIdx].isSelected = true;
      const report = { ...this.state.report, rows: newRows, selectedRows };
      this.setState({ report, session_id: rows[0].row.Session_id });
    };

    const onRowsDeselected = (rows) => {
      const newRows = [...this.state.report.rows];
      newRows.map((row) => {
        row.isSelected = false;
      });
      const selectedRows = [];
      const report = { ...this.state.report, rows: newRows, selectedRows };
      this.setState({ report, session_id: null });
    };

    let that = this;

    const verifyFormatter = React.createClass({
      render() {
        return (
          this.props.dependentValues.NeedsVerification) ?
            <span>
              <Button
                bsStyle="primary"
                className="textAlignStyle"
                style={{ height: '23px', width: '39px', padding: '0px' }}
                onClick={() => {
                  /*
                  var ProductNum = this.props.dependentValues.ProductNum;
                  that.removeRow(ProductNum);
                  */
                  that.openCashOutModal(this.props.dependentValues);
                }}
              >Verify
              </Button>
            </span> :
            <span>
              {(this.props.dependentValues.Verifier) ? this.props.dependentValues.Verifier : ''}
            </span>;
      },
    });

    const logFormatter = React.createClass({
      render() {
        return (
          <span>
            <Button
              bsStyle="primary"
              className="textAlignStyle"
              style={{ height: '23px', width: '39px', padding: '0px' }}
              onClick={() => {
                that.openLogModal(this.props.dependentValues);
              }}
            >
            View
            </Button>
          </span>
        );
      },
    });

    const showBalanceFormatter = React.createClass({
      render() {
        return (
          <span>{(this.props.dependentValues.Verifier) ? this.props.dependentValues.Balance: ''}</span>
        );
      },
    });

    const showCountFormatter = React.createClass({
      render() {
        return (
          <span>{(this.props.dependentValues.Verifier) ? this.props.dependentValues.Transactions : ''}</span>
        );
      },
    });

    const columns = [
      {
        key: 'POSRegister_id',
        name: <Translate value="reg" />,
        width: 40,
        resizable: true,
        sortable: true,
      },
      {
        key: 'Session_id',
        name: <Translate value="id" />,
        width: 25,
        resizable: true,
        sortable: true,
        editable: true,
      },
      {
        key: 'Date',
        name: <Translate value="date" />,
        width: 80,
        resizable: true,
        sortable: true,
        editable: true,
      },
      {
        key: 'NewCashInTime',
        name: <Translate value="in" />,
        width: 80,
        resizable: true,
        sortable: true,
        editable: true,
      },
      {
        key: 'CashInBy',
        name: <Translate value="in_by" />,
        width: 80,
        resizable: true,
        sortable: true,
        editable: true,
      },
      {
        key: 'NewCashOutTime',
        name: <Translate value="out" />,
        width: 80,
        resizable: true,
        sortable: true,
        editable: true,
      },
      {
        key: 'CashOutBy',
        name: <Translate value="out_by" />,
        width: 80,
        resizable: true,
        sortable: true,
        editable: true,
      },
      {
        key: 'StartingCash',
        name: <Translate value="cash_in" />,
        width: 80,
        resizable: true,
        sortable: true,
        editable: true,
      },
      {
        key: 'Transactions',
        name: <Translate value="invoice_count" />,
        width: 80,
        resizable: true,
        sortable: true,
        editable: true,
        formatter: showCountFormatter,
        getRowMetaData: row => row,
      },
      {
        key: 'TotalCashAmount',
        name: <Translate value="by_cash" />,
        width: 80,
        resizable: true,
        sortable: true,
        editable: true,
      },
      {
        key: 'CreditCards',
        name: <Translate value="by_card" />,
        width: 80,
        resizable: true,
        sortable: true,
        editable: true,
      },
      {
        key: 'EBTCards',
        name: <Translate value="by_ebt" />,
        width: 80,
        resizable: true,
        sortable: true,
        editable: true,
      },
      {
        key: 'Checks',
        name: <Translate value="by_check" />,
        width: 80,
        resizable: true,
        sortable: true,
        editable: true,
      },
      {
        key: 'StoreCredit',
        name: <Translate value="store_credit" />,
        width: 80,
        resizable: true,
        sortable: true,
        editable: true,
      },
      {
        key: 'TotalPaidOut',
        name: <Translate value="returns" />,
        width: 80,
        resizable: true,
        sortable: true,
        editable: true,
      },
      {
        key: 'TotalNetSale',
        name: <Translate value="net_sale" />,
        width: 80,
        resizable: true,
        sortable: true,
        editable: true,
      },
      {
        key: 'SalesTax',
        name: <Translate value="total_tax" />,
        width: 80,
        resizable: true,
        sortable: true,
        editable: true,
      },
      {
        key: 'TotalSale',
        name: <Translate value="total_sale" />,
        width: 80,
        resizable: true,
        sortable: true,
        editable: true,
      },
      {
        key: 'Balance',
        name: <Translate value="balance" />,
        width: 80,
        resizable: true,
        sortable: true,
        editable: true,
        formatter: showBalanceFormatter,
        getRowMetaData: row => row,
      },
      {
        key: 'Verifier',
        name: <Translate value="verifier" />,
        width: 80,
        resizable: true,
        sortable: true,
        editable: true,
        formatter: verifyFormatter,
        getRowMetaData: row => row,
      },
      {
        key: 'ViewLogs',
        name: <Translate value="logs" />,
        resizable: true,
        sortable: true,
        editable: true,
        formatter: logFormatter,
        getRowMetaData: row => row,
      },
    ];

    if (isARC) {
      const  ChecksIdx = _.findIndex(columns, { key: 'Checks' });
      const giftcard = {
        key: 'Giftcards',
        name: <Translate value="gift_card" />,
        width: 80,
        resizable: true,
        sortable: true,
        editable: true,
      }
      columns.splice(ChecksIdx, 0, giftcard)
    }

    return (
      <Row>
        <Col xs={12}>
          <div id="PosReport-dataGrid1">
            <ReactDataGrid
              onGridSort={handleGridSort}
              onAddFilter={handleFilterChange}
              enableRowSelect="single"
              columns={columns}
              rowGetter={rowGetter}
              rowsCount={getSize()}
              rowHeight={25}
              headerRowHeight={45}
              minHeight={tableHeight}
              onRowUpdated={handleRowUpdated}
              onRowSelect={onRowSelect}
              rowSelection={{
                showCheckbox: true,
                onRowsSelected,
                onRowsDeselected,
                selectBy: {
                  isSelectedKey: 'isSelected',
                },
              }}
            />
          </div>
        </Col>
      </Row>
    );
  }

  renderHeader = (Name, id) => {
    return (
      <label style={(this.state.curRegisterId === id) ? { cursor: 'pointer', 'background-color': 'rgb(255, 236, 179)' } : { cursor: 'pointer' }}>{Name}</label>
    );
  }

  getSessions = (id) => {
    const { fetchRegisterSessionsByDate, fetchRegisterSessions } = this.props;
    const { FromDate, ToDate } = this.state;

    if (id === '') {
      this.setState({ curRegisterId: 'All' });
      if (FromDate && ToDate) {
        this.props.fetchAllRegisterSessions(FromDate, ToDate, this.props.selectedCompany);
      }
      return;
    } else {
      this.setState({ curRegisterId: id });
    }

    if (FromDate && ToDate) {
      fetchRegisterSessionsByDate(id, FromDate, ToDate, this.props.selectedCompany);
    } else {
      fetchRegisterSessions(id, this.props.selectedCompany);
    }
  }

  renderRegisters() {
    if (!this.props.registers) return;
    const registers = this.props.registers;
    let num = -1;
    return registers.map((registers) => {
      num += 1;
      const index = num;
      return <Panel className="panelStyle" style={{ cursor: 'pointer' }} key={index} onClick={() => { this.getSessions(this.props.registers[index].Register_id); }} header={this.renderHeader(this.props.registers[index].Name, this.props.registers[index].Register_id)} />
    });
  }

  handleInputChange = (event) => {
    const state = { ...this.state };
    state[event.target.name] = event.target.value;
    this.setState({ state });
  }

  renderRegistersHeader() {
    const Today = new Date();
    return (
      <DateTimePicker
        id="all-register-datepicker"
        format="MM-DD-YY"
        max={Today}
        onChange={(e) => {
          this.setState({ RegistersDate: e });
        }}
        time={false}
        value={this.state.RegistersDate}
      />
    );
  }

  renderPrintAllReportsButton() {
    const { fromDate, toDate } = toFromDates(-1, this.state.RegistersDate, this.state.RegistersDate, '', isTU);
    let url = `${ROOT_URL}v1/pos/print/register_daily_report/?CashInTime__gte=${fromDate}&CashInTime__lte=${toDate}&Bearer=${localStorage.getItem('token')}`;
    let company = this.props.selectedCompany.value ? this.props.selectedCompany.value : this.props.selectedCompany;
    if (isGFD || isCTP) {
      url = `${ROOT_URL}v1/pos/print/register_daily_report/?CashInTime__gte=${fromDate}&CashInTime__lte=${toDate}&Bearer=${localStorage.getItem('token')}&Company_id=${company}`;
    }
    return (
      <Button
        bsStyle="primary"
        style={{ marginBottom: '10px', marginTop: '2px' }}
        disabled={this.state.RegistersDate === '' || this.state.RegistersDate === null}
        href={url}
      >
        <em className="fa fa-download" /><Translate value="print_daily_report" />
      </Button>
    );
  }

  renderExportAllReportsButtonCsv() {
    // const { fromDate, toDate } = toFromDates(-1, this.state.RegistersDate, this.state.RegistersDate);
    const { fromDate, toDate } = toFromDates(-1, this.state.FromDate, this.state.ToDate);
    const url = `${ROOT_URL}v1/pos/group_sales_report?start_date=${fromDate}&end_date=${toDate}&format=csv&Bearer=${localStorage.getItem('token')}`;
    return (
      <Button
        bsStyle="primary"
        style={{ marginBottom: '10px', marginTop: '2px' }}
        disabled={this.state.RegistersDate === '' || this.state.RegistersDate === null}
        href={url}
      >
        <em className="fa fa-download" /><Translate value="department_sales_report" /> (CSV)
      </Button>
    );
  }

  renderExportAllReportsButtonPdf() {
    // const { fromDate, toDate } = toFromDates(-1, this.state.RegistersDate, this.state.RegistersDate);
    const { fromDate, toDate } = toFromDates(-1, this.state.FromDate, this.state.ToDate);
    const url = `${ROOT_URL}v1/pos/group_sales_report?start_date=${fromDate}&end_date=${toDate}&format=pdf&Bearer=${localStorage.getItem('token')}`;
    return (
      <Button
        bsStyle="primary"
        style={{ marginBottom: '10px', marginTop: '2px', marginLeft: '8px' }}
        disabled={this.state.RegistersDate === '' || this.state.RegistersDate === null}
        href={url}
      >
        <em className="fa fa-download" /><Translate value="department_sales_report" /> (PDF)
      </Button>
    );
  }

  renderArrivalPrice = (summary) => {
    if (isSH || isAP) {
      return <Col xs={2}>
      <label className="col-xs-6"><Translate value="mobile" /></label>
      <Col xs={6}>
        <Input type="text" disabled value={summary.MobileAmount} />
      </Col>
    </Col>
    }
    return <Col xs={2}>
    <label className="col-xs-6"><Translate value="arrival_price" /></label>
    <Col xs={6}>
      <Input type="text" disabled value={summary.TotalArrivalPrice} />
    </Col>
  </Col>
  }

  render() {
    const CashOutModalTitle = <Translate value="counted_amount_report" />;
    const CashOutModalStyle = {
      height: '500px',
      width: '1000px',
      marginLeft: '-28%',
      marginTop: '-20%',
    };
    const LogModalTitle = <Translate value="log_report" />;
    const LogModalStyle = {
      height: '400px',
      width: '1000px',
      marginLeft: '-28%',
      marginTop: '-20%',
    };

    let url = `${ROOT_URL}/v1/pos/print/activities_log/${this.state.session_id}?Bearer=${localStorage.getItem('token')}`;
    let printTransactionsUrl = `${ROOT_URL}/v1/pos/print/transactions/${this.state.session_id}?Bearer=${localStorage.getItem('token')}`;

    let company = this.props.selectedCompany.value ? this.props.selectedCompany.value : this.props.selectedCompany;
    if (isGFD || isCTP) {
      url = `${ROOT_URL}/v1/pos/print/activities_log/${this.state.session_id}?Bearer=${localStorage.getItem('token')}&Company_id=${company}`;
      printTransactionsUrl = `${ROOT_URL}/v1/pos/print/transactions/${this.state.session_id}?Bearer=${localStorage.getItem('token')}&Company_id=${company}`;
    }

    const summary = this.getAmountSummary(this.props.sessions);

    return (
      //---------------
      // Begin HTML
      //---------------
      <ContentWrapper>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Translate value="POS_management" />
          </Breadcrumb.Item>
          <Breadcrumb.Item active="true">
            <Translate value="pos_report" />
          </Breadcrumb.Item>
        </Breadcrumb>

        <Grid id="pos-report">
          <Row>
            <Panel id="date-range-picker">
              <Col xs={2}>
                <Col xs={4}>
                  <h3 className="filter-title"><Translate value="date" /><span className="colon">:</span></h3>
                </Col>
                <Col xs={8}>
                  { this.renderRegistersHeader() }
                </Col>
              </Col>
              <Col xs={9}>
              <ButtonToolbar>
                {this.renderPrintAllReportsButton()}
                {/* {isARC && this.renderExportAllReportsButtonCsv()}
                {isARC && this.renderExportAllReportsButtonPdf()} */}
                </ButtonToolbar>
              </Col>
            </Panel>
          </Row>
          <Row>
            <Col xs={2} className="category-nav-panel">
              <Panel id="category-nav" className="panelStyle" style={{ overflow: 'visible' }}>
                <Panel
                  className="panelStyle"
                  key={0}
                  onClick={() => { this.getSessions(''); }}
                  header={this.renderHeader('All', 'All')}
                />
                {this.renderRegisters()}
              </Panel>
            </Col>
            <Col xs={10}>
              <Row>
                <Panel id="reports-panel">
                  <Row id="date-range-picker">
                    {/* <Col xs={2}>
                      <h3 className="filter-title"><Translate value="cash_in_time" /><span className="colon">:</span></h3>
                    </Col> */}
                    <Col xs={5}>
                      <Row>
                        <Col xs={12}>
                          <Col xs={5}>
                          <h3 className="filter-title"><Translate value="cash_in_time" /><span className="colon">:</span></h3>
                          </Col>
                          <Col xs={3}>
                            <DateTimePicker
                              id="from-datepicker"
                              format="MM-DD-YY"
                              onChange={(e) => {
                                if (e > this.state.ToDate) {
                                  return;
                                }
                                this.setState({ FromDate: e }, () => {
                                    if (this.state.curRegisterId === 'All') {
                                      this.props.fetchAllRegisterSessions(this.state.FromDate, this.state.ToDate, this.props.selectedCompany);
                                      return;
                                    }
                                    this.getSessions(this.state.curRegisterId, this.state.FromDate, this.state.ToDate);
                                  });
                              }}
                              max={this.state.ToDate}
                              time={false}
                              value={this.state.FromDate}
                            />
                          </Col>
                          <Col xs={3}>
                            <DateTimePicker
                              id="to-datepicker"
                              format="MM-DD-YY"
                              onChange={(e) => {
                                if (e < this.state.FromDate) {
                                  return;
                                }
                                this.setState({ ToDate: e }, () => {
                                    if (this.state.curRegisterId === 'All') {
                                      this.props.fetchAllRegisterSessions(this.state.FromDate, this.state.ToDate, this.props.selectedCompany);
                                      return;
                                    }
                                    this.getSessions(this.state.curRegisterId, this.state.FromDate, this.state.ToDate);
                                  });
                              }}
                              min={this.state.FromDate}
                              time={false}
                              value={this.state.ToDate}
                            />
                          </Col>
                        </Col>
                      </Row>
                    </Col>
                    <Col xs={6}>
                    {isARC && this.renderExportAllReportsButtonCsv()}
                {isARC && this.renderExportAllReportsButtonPdf()}
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12}>
                      <Button
                        bsStyle="primary"
                        style={{ marginBottom: '10px' }}
                        disabled={this.state.report.selectedRows.length === 0}
                        href={url}
                      >
                        <em className="fa fa-print" /><Translate value="print_session_report" />
                      </Button>
                      <Button
                        bsStyle="primary"
                        style={{ marginBottom: '10px', marginLeft: '10px' }}
                        disabled={this.state.report.selectedRows.length === 0}
                        href={printTransactionsUrl}
                      >
                        <em className="fa fa-print" /><Translate value="print_transactions" />
                      </Button>
                    </Col>
                  </Row>
                  {this.renderReportTable()}
                </Panel>
              </Row>
              <Row>
                <Panel className="form-horizontal">
                  <Col xs={2} className="vertical-divider">
                    <label className="col-xs-12"><Translate value="invoice_count" /></label>
                    <Col xs={8}>
                      <Input type="text" disabled value={summary.transactions} />
                    </Col>
                  </Col>
                  <Col xs={10}>
                    <Col xs={2}>
                      <label className="col-xs-6"><Translate value="cash" /></label>
                      <Col xs={6}>
                        <Input type="text" disabled value={summary.totalCashAmount} />
                      </Col>
                    </Col>
                    <Col xs={2}>
                      <label className="col-xs-6"><Translate value="card" /></label>
                      <Col xs={6}>
                        <Input type="text" disabled value={summary.creditCards} />
                      </Col>
                    </Col>
                    <Col xs={2}>
                      <label className="col-xs-6"><Translate value="ebt" /></label>
                      <Col xs={6}>
                        <Input type="text" disabled value={summary.ebtCards} />
                      </Col>
                    </Col>
                    <Col xs={2}>
                      <label className="col-xs-6"><Translate value="check" /></label>
                      <Col xs={6}>
                        <Input type="text" disabled value={summary.checks} />
                      </Col>
                    </Col>
                    <Col xs={2}>
                      <label className="col-xs-6"><Translate value="credit" /></label>
                      <Col xs={6}>
                        <Input type="text" disabled value={summary.storeCredit} />
                      </Col>
                    </Col>
                    <Col xs={2}>
                      <label className="col-xs-6"><Translate value="gift_card" /></label>
                      <Col xs={6}>
                        <Input type="text" disabled value={summary.giftcards} />
                      </Col>
                    </Col>
                    <Col xs={2}>
                      <label className="col-xs-6"><Translate value="returns" /></label>
                      <Col xs={6}>
                        <Input type="text" disabled value={summary.totalPaidOut} />
                      </Col>
                    </Col>
                    <Col xs={2}>
                      <label className="col-xs-6"><Translate value="net_sale" /></label>
                      <Col xs={6}>
                        <Input type="text" disabled value={summary.totalNetSale} />
                      </Col>
                    </Col>
                    <Col xs={2}>
                      <label className="col-xs-6"><Translate value="total_tax" /></label>
                      <Col xs={6}>
                        <Input type="text" disabled value={summary.salesTax} />
                      </Col>
                    </Col>
                    <Col xs={2}>
                      <label className="col-xs-6"><Translate value="total_sale" /></label>
                      <Col xs={6}>
                        <Input type="text" disabled value={summary.totalSale} />
                      </Col>
                    </Col>
                    <Col xs={2}>
                      <label className="col-xs-6"><Translate value="profit" /></label>
                      <Col xs={6}>
                        <Input type="text" disabled value={summary.Profit} />
                      </Col>
                    </Col>
                    {this.renderArrivalPrice(summary)}
                  </Col>
                </Panel>
              </Row>
            </Col>
          </Row>
        </Grid>
        <SkyLightStateless
          dialogStyles={CashOutModalStyle}
          isVisible={this.state.CashOutModalOpen}
          title={CashOutModalTitle}
          onCloseClicked={() => {
            this.closeCashOutModal();
          }}
        >
          <CashOutModal rowProps={this.state.rowProps} finishedSubmit={this.closeCashOutModal} curRegisterId={this.state.curRegisterId} />
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={LogModalStyle}
          isVisible={this.state.LogModalOpen}
          title={LogModalTitle}
          onCloseClicked={() => {
            this.closeLogModal();
          }}
        >
          <LogModal rowProps={this.state.rowProps} />
        </SkyLightStateless>
      </ContentWrapper>
      //---------------
      // End HTML
      //---------------
    );
  }
}

export default PosReport;



// WEBPACK FOOTER //
// ./master/jsx/components/Sales/posReport.jsx